import { createContext, type FC, type PropsWithChildren, useCallback, useContext, useState } from "react";

export const ActionTypeEnum = {
    Changes: "Changes",
    NextPayment: "NextPayment",
    Payments: "Payments",
    Report: "Report",
    Fond: "Fond",
    FondBankId: "FondBankId",
    TaxCertificate: "TaxCertificate",
    EmployerContribution: "EmployerContribution",
    Inflation: "Inflation",
    Coverage: "Coverage",
    ChangeAdress: "ChangeAdress",
    InvestmentStrategy: "InvestmentStrategy",
    InvestmentStrategyBankId: "InvestmentStrategyBankId",
    ContributionWithQuestionare: "ContributionWithQuestionare",
} as const;

export type ActionType = (typeof ActionTypeEnum)[keyof typeof ActionTypeEnum] | undefined;

export type ActionWithContextType = {
    type: ActionType;
    context?: Record<string, unknown>;
};

export type ActionContext = {
    action: ActionWithContextType | undefined;
    setAction: (action: ActionWithContextType) => void;
    clearAction: () => void;
};

const SmartActionContext = createContext<ActionContext | undefined>(undefined);

export default SmartActionContext;

export const SmartActionProvider: FC<PropsWithChildren> = ({ children }) => {
    const [action, setAction] = useState<ActionWithContextType | undefined>(undefined);
    const clearAction = useCallback((): void => {
        setAction(undefined);
    }, []);

    return (
        <SmartActionContext.Provider
            value={{
                action,
                setAction,
                clearAction,
            }}
        >
            {children}
        </SmartActionContext.Provider>
    );
};

export function useSmartAction(): ActionContext {
    return useContext(SmartActionContext);
}
